import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import CustomerGroupTable from './CustomerGroupTable';

interface ICustomerGroupProps extends RouteComponentProps<{
  eshop: string;
  groupId: string;
}> {

}

export default class CustomerGroup extends React.Component<ICustomerGroupProps> {

  render() {
    return (
      <div>
        <CustomerGroupTable
          domain={this.props.match.params.eshop}
          groupId={this.props.match.params.groupId}
        />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/scenes/CustomerGroup/index.tsx